import React, { useState, useTransition , useMemo } from "react";
import * as Ariakit from "@ariakit/react";
import { matchSorter } from "match-sorter";
import styles from "./NewMultiSelect.module.css"
interface Props {
  options: string[];
  selected: any;
  setSelected: Function;
  title: string;
  style?: any;
  allowAdd?: boolean;
  onAdd?: any;
  transparent?: boolean;
  /** When set, search matches labels; list items show labels (values stay canonical). */
  getOptionLabel?: (value: string) => string;
}

const NewMultiSelect = ({
  options,
  selected,
  setSelected,
  title,
  style,
  allowAdd,
  onAdd,
  transparent,
  getOptionLabel,
}: Props) => {
    const [isPending, startTransition] = useTransition();
    const [searchValue, setSearchValue] = useState("");
    
    const matches = useMemo(() => {
      const selectedSet = new Set(selected);
      const pool = [...options].filter((o) => !selectedSet.has(o));
      const sortedPool = getOptionLabel
        ? matchSorter(pool, searchValue, {
            keys: [(item) => getOptionLabel(item as string)],
          })
        : matchSorter(pool, searchValue);
      return selected.concat(sortedPool);
    }, [searchValue, options, selected, getOptionLabel]);
    const hasExact = useMemo(() => {
      if (!allowAdd) {
        return false
      }
      const matched = matches.find(match => match === searchValue)
      return matched !== null && matched !== undefined;
    }, [matches, allowAdd])
  return (
    <Ariakit.ComboboxProvider
    selectedValue={selected}
    setSelectedValue={(value) => setSelected(value)}
    setValue={(value) => {
      startTransition(() => {
        setSearchValue(value);
      });
    }}
  >
    <div className={`${styles["combobox-wrapper"]}`} style={style}>
    <Ariakit.Combobox
      placeholder={title}
      className={!transparent ? styles.combobox : `${styles.combobox} ${styles.transparent}`}
      
      />
    <Ariakit.ComboboxDisclosure className={`${styles.button} ${styles.secondary} ${styles.disclosure}`} />
    </div>
    <Ariakit.ComboboxPopover
      sameWidth
      gutter={8}
      className={styles.popover}
      aria-busy={isPending}
      key={matches.length}
    >
      {matches.map((value) => (
        <Ariakit.ComboboxItem
          key={value}
          value={value}
          focusOnHover
          className={styles["combobox-item"]}
        >
          <Ariakit.ComboboxItemCheck />
          {getOptionLabel ? getOptionLabel(value) : value}
        </Ariakit.ComboboxItem>
      ))}
      {searchValue.length > 0 && allowAdd && !hasExact && <div style={{cursor: "pointer"}} onClick={() => onAdd(searchValue)}>+ Add "{searchValue}"</div> }
      {matches.length === 0 && <div className={styles["no-results"]}>No results found</div>}
    </Ariakit.ComboboxPopover>
  </Ariakit.ComboboxProvider>
  );
};
export default (NewMultiSelect);
